import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, Popup, Icon, Dimmer, Loader, Segment, List} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';

const {fetchPermissionFromPolicy} = Actions;

const InfoModal = ({
  loading,
  id,
  list,
  name,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    dispatch(fetchPermissionFromPolicy(id));
    setModalIsOpen(true);
  };

  return (
    <Modal
      onOpen={openModal}
      onClose={closeModal}
      open={modalIsOpen}
      closeIcon
      size='tiny'
      className='warranty-report-modal'
      trigger={
        <Popup
          trigger={
            <Icon
              link
              name='info circle'
              color='blue'
              size='large'
              onClick={openModal}
            />
          }
          on='click'
          position='bottom left'
          inverted
        >
          <div>Políticas</div>
        </Popup>
      }
    >
      <Modal.Header>Detalle Política {name}</Modal.Header>
      <Modal.Content>
        {loading ? (
          <Segment basic padded='very'>
            <Dimmer active inverted>
              <Loader inverted content='Cargando políticas' />
            </Dimmer>
          </Segment>
        ) : (
          <List bulleted>
            {list.map((permission, idx) => {
              return <List.Item key={idx}>{permission?.name}</List.Item>;
            })}
          </List>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default InfoModal;
